import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  TextField,
} from "@mui/material";
import QRCode from "qrcode.react";

const Ticket = ({
  title,
  director,
  date,
  image,
  ChangeColor,
  bgColor,
  festivalName,
  qrCode,
  type,
}) => {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editableTitle, setEditableTitle] = useState(title);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleInputChange = (event) => {
    setEditableTitle(event.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setIsEditing(false);
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      // Customize the locale and options as needed
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };
  return (
    <Box sx={{ position: "relative", perspective: 1000 }}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 600,
          height: 150,
          transformStyle: "preserve-3d",
          transition: "transform 0.6s",
          transform: isFlipped ? "rotateY(180deg)" : "none",
        }}
      >
        {/* Front Side */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            borderRadius: "8px",
            overflow: "hidden",
            display: "flex",
          }}
        >
          <Grid container spacing={0} sx={{ height: "100%" }}>
            <Grid
              item
              xs={8}
              sx={{
                backgroundColor: ChangeColor ? ChangeColor : bgColor,
                padding: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <CardContent sx={{ padding: "2px !important" }}>
                <Typography variant="subtitle2" color="textSecondary">
                  {type ? type : "THE BRONZE KEEP THEATRE"}
                </Typography>

                <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                  {isEditing ? (
                    <TextField
                      value={editableTitle}
                      onChange={handleInputChange}
                      onBlur={handleBlur}
                      onKeyDown={handleKeyDown}
                      autoFocus
                      variant="outlined"
                      size="small"
                      sx={{ flexGrow: 1 }}
                    />
                  ) : (
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: "bold", cursor: "pointer" }}
                      component="div"
                      onClick={handleEditClick}
                    >
                      {editableTitle}
                    </Typography>
                  )}
                  {qrCode ? (
                    <img
                      src={qrCode}
                      alt="QR Code"
                      style={{ maxWidth: "18%" }}
                    />
                  ) : (
                    <QRCode value="hello" size={40} />
                  )}
                </Box>
                <Typography variant="subtitle1" color="textSecondary">
                  Directed by {director}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {formatDate(date)}
                </Typography>
              </CardContent>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 1,
                backgroundColor: "#FFF",
              }}
            >
              <Box sx={{ transform: "rotate(90deg)", textAlign: "center" }}>
                <Typography variant="subtitle2" color="textSecondary">
                  {festivalName ? festivalName : "THE BRONZE KEEP THEATRE"}
                </Typography>
                <Typography
                  sx={{ fontWeight: "bold", color: "black" }}
                  variant="h7"
                >
                  {editableTitle}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  Directed by {director}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  FREE SEATING
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>

        {/* Back Side */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            borderRadius: "8px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: bgColor,
            color: "white",
          }}
        >
          <Typography variant="h6">{festivalName}</Typography>
        </Card>
      </Box>
    </Box>
  );
};

export default Ticket;
